/*
 * カートドロワーの閾値プログレスのふるまい。
 *
 * 表示自体は snippets/cart-tier-progress.liquid がサーバー側で組み立てる。
 * ここが担うのは、サーバーでは持てない 2 つだけ:
 *   1. 「閉じる」状態の保持（sessionStorage）
 *   2. レコメンドの 1 タップ追加
 *
 * ドロワーは innerHTML の差し替えで再描画されるため inline script は再実行されない。
 * カスタム要素にすることで、差し替え後も connectedCallback が自動で走る。
 */
class CartTierProgress extends HTMLElement {
  connectedCallback() {
    this.reco = this.querySelector('[data-reco]');

    // 一度閉じたらセッション中は出し直さない。カート変更のたびに復活させると
    // 「閉じる」が機能せず、押し付けと受け取られる。
    if (this.reco && this.isDismissed()) {
      this.reco.hidden = true;
    }

    const dismissButton = this.querySelector('[data-reco-dismiss]');
    if (dismissButton) {
      dismissButton.addEventListener('click', this.onDismiss.bind(this));
    }

    const addButton = this.querySelector('[data-reco-add]');
    if (addButton) {
      addButton.addEventListener('click', this.onAdd.bind(this));
    }
  }

  isDismissed() {
    // プライベートウィンドウなど sessionStorage が例外を投げる環境がある。
    try {
      return sessionStorage.getItem(CartTierProgress.STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  onDismiss() {
    if (this.reco) this.reco.hidden = true;

    try {
      sessionStorage.setItem(CartTierProgress.STORAGE_KEY, '1');
    } catch (error) {
      // 保持できなくても表示は閉じた状態にするため、ここでは何もしない
    }
  }

  onAdd(event) {
    const button = event.currentTarget;
    const variantId = button.dataset.recoAdd;
    if (!variantId || button.disabled) return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    button.disabled = true;

    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: drawer.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          console.error('cart-tier-progress: 追加に失敗しました', parsedState.message);
          button.disabled = false;
          return;
        }
        // 再描画で要素ごと差し替わるため、ボタンの disabled を戻す必要はない
        drawer.renderContents(parsedState);

        // 同一ページ内のカート連動 UI（price-per-item / product-info 等）が
        // 取り残されないよう、他の追加経路と同じイベントを流す
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-tier-progress',
          productVariantId: variantId,
          cartData: parsedState,
        });
      })
      .catch((error) => {
        console.error('cart-tier-progress: 追加に失敗しました', error);
        button.disabled = false;
      });
  }
}

CartTierProgress.STORAGE_KEY = 'bs-cart-tier-reco-dismissed';

customElements.define('cart-tier-progress', CartTierProgress);
